// Aviso regulatório (Medida Provisória): enquanto `enabled`, o modal de
// depósito vira um aviso de "Depósitos suspensos" — sem formulário, sem
// métodos e sem o auto-submit do deeplink ?open=pix&value=.
//
// Pra reativar os depósitos: `enabled: false`. É build-time, então só vale
// depois de build + deploy.
//
// O bloqueio é só visual: /wallet/add-credit continua indo pro backend, que
// precisa aplicar o bloqueio de verdade.
export const depositSuspensionNotice = {
  enabled: true,
  title: 'Depósitos suspensos',
  message:
    'Em cumprimento à nova Medida Provisória, não estamos mais aceitando depósitos. Apostas e saques continuam disponíveis até as 23h59 do dia 5/10.',
  reassurance: 'Fique tranquilo: seu saldo está seguro na ApostaTudo.',
  dismissLabel: 'Entendi',
} as const;

export function isDepositSuspended(): boolean {
  return depositSuspensionNotice.enabled;
}
